import * as DropdownMenu from '@wandb/weave/components/DropdownMenu';
import * as React from 'react';

import {Sort} from '../../../util/queryTypes';
import {ResetColorRun, useResetColors} from './useResetColors';

export const ResetRunColors = ({
  sort,
  rows,
}: {
  sort: Sort;
  rows: ResetColorRun[];
}) => {
  const resetRunColorsConfig = useResetColors({sort, rows});
  return (
    <>
      <DropdownMenu.Item
        disabled={
          rows.length < 2 || // if only one row
          (!resetRunColorsConfig.modifiedSort &&
            !resetRunColorsConfig.hasActiveFilter &&
            !resetRunColorsConfig.hasActiveSearch &&
            !resetRunColorsConfig.hasActiveGroupKeys)
        }
        onSelect={resetRunColorsConfig.randomizeColors}>
        Randomize colors
      </DropdownMenu.Item>
      <DropdownMenu.Item
        disabled={!resetRunColorsConfig.hasCustomRunColors}
        onSelect={resetRunColorsConfig.resetColors}>
        Reset colors
      </DropdownMenu.Item>
    </>
  );
};
